import { render, staticRenderFns } from "./administrationTileVideoCreator.vue?vue&type=template&id=5c0474a9&"
import script from "./administrationTileVideoCreator.vue?vue&type=script&lang=js&"
export * from "./administrationTileVideoCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports